import React from "react";

export const Services = (props) => {
  return (
    <div id="services" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Our Products</h2>
          <p>
            Nexagen Solution is a user-friendly online web application offering a variety of solutions across multiple industries. Explore our diverse range of products, each designed to meet your specific needs.
          </p>
        </div>
        <div className="row">
          {props.data ? (
            props.data.map((service, index) => (
              <div key={`${service.title}-${index}`} className="col-12 col-sm-6 col-md-4 mb-4">
                <div className="service-card h-100 d-flex flex-column">
                  <div className="service-img-container">
                    <img 
                      src={service.image} 
                      alt={service.title} 
                      className="service-img img-fluid"
                      onError={(e) => {
                        e.target.src = 'path/to/default-image.jpg'; // Fallback image
                      }}
                    />
                  </div>
                  <div className="service-content flex-grow-1">
                    <h3>{service.title}</h3>
                    <p>{service.description}</p>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="loading-spinner">
              {/* Add your loading spinner or message */}
              Loading products...
            </div>
          )}
        </div>
      </div>
    </div>
  );
};